import React, { useEffect, useState } from "react";
import "./HomeScreen.css";
import { authenticateUser, pinpointStatus, storeUserDetails } from "../../redux/slices/authSlice";
import { AppDispatch, RootState } from "../../redux/store/store";
import { useDispatch, useSelector } from "react-redux";
import SidebarContainer from "../../components/SidebarContainer/SidebarContainer";
import GlobalBackground from "../../components/GlobalBackground/GlobalBackground";
import PinPointsContainer from "../../components/PinPointsContainer/PinPointsContainer";
import CommonLoginToHeader from "../../components/CommonLoginToHeader/CommonLoginToHeader";
import { useNavigate } from "react-router-dom";
import { showErrorToast } from "../../utils/ToastMessages/ToastMessages";
import { getCreatedAddress } from "../../api/apiServices";

const HomeScreen = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state: RootState) => state?.auth.token); 
  const [pinpoint, setPinpoint] = useState<any>({username: '', email: '', name: '', addresses:[]});

  useEffect(()=> {
    getUserAddresses();
  },[])

  const getUserAddresses = async () => {
    try {
      const addresses: any = await getCreatedAddress(token);
      if (addresses?.status) {
        const details:any = {name: addresses.data.name, username:addresses.data.username, email:addresses.data.email}
        dispatch(storeUserDetails(details));
        setPinpoint(addresses.data);
      } else {
        showErrorToast("Failed To fetch Data!");
      }
    } catch (error: any) {
      navigate("/");
      // console.log("==========>>>>>>", error);
      showErrorToast(error?.response?.data?.error || "Failed To fetch Data!");
    }
  }
  return (
    <GlobalBackground>
      <div className="home-outer">
        <CommonLoginToHeader
          title={"PinPoint Addresses"}
          screen={"login"}
          backScreen={""}
        />
        <SidebarContainer />
      </div>

      <h1 className="home-pinpoint">My PinPoints</h1>
      <PinPointsContainer pinpoint={pinpoint?.addresses} userDetails={pinpoint}/>

      <div
        onClick={() => {
          navigate("/register");
        }}
        className="home-button"
      >
        <button type="submit">Add New PinPoint</button>
      </div>
    </GlobalBackground>
  );
};

export default HomeScreen;
